var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "promptDialog" },
    [
      !!_vm.content
        ? _c("div", [_c("pre", [_vm._v(_vm._s(_vm.content))])])
        : _vm._e(),
      _vm._l(_vm.value, function (field) {
        return _c("div", { key: field.id, staticClass: "promptWrapper" }, [
          field.label
            ? _c("span", [_vm._v(_vm._s(field.label)), _c("br")])
            : _vm._e(),
          _c("input", {
            ref: "input-" + field.id,
            refInFor: true,
            attrs: {
              autofocus: field.autoFocus,
              placeholder: field.placeholder,
            },
            domProps: { value: field.value },
            on: {
              change: function ($event) {
                return _vm.onInputChange(field.id, $event.target.value)
              },
            },
          }),
        ])
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }